/**
 * @author Leonel Martinez
 * @module settings
 * @fileoverview `Vuex settings module` that comes back from the settings API.
 */
import { settingsService } from "@/services";
import { MESSAGES } from "@/utils";
import { rootAction } from '../index'

const storage = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCALSTORAGE_SETTINGS));


export const settings = {
  namespaced: true,
  state: {
    toolbar: {
      fixed: true,
      clippedLeft: false
    },
    partsResultPage: storage?.partsResultPage,
    displayCompatibilityMessage: storage?.displayCompatibilityMessage || true,
    ieVersion: -1,
    error: {
      status: false,
      message: null,
      attempts: 0
    },
    skin: storage?.skin,
  },
  actions: {
    /**
   * @description Load the config document
   * @returns {Promise}
   */
    GET_SKIN: async ({ commit, dispatch }) => {
      const response = await settingsService.getSkin();
      console.log("Get skin response:", response);

      if (response.statusText != "OK") {
        dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.SERVER_ERROR, rootAction);
        return;
      }

      commit("SET_THEME", response.data);
    },
    SET_PARTS_RESULT_RETURN_PAGE({ commit }, page) {
      commit("SET_PART_RESULT_RETURN_PAGE", page);
    },
    GET_PARTS_RESULT_RETURN_PAGE({ state }) {
      return state.partsResultPage;
    },
    SET_IE_VERSION({ commit }, ieVersion) {
      commit("SET_IE_VERSION", ieVersion);
    },
    SET_DISPLAY_COMPATIBILITY_MESSAGE({ commit }, display) {
      commit("SET_DISPLAY_COMPATIBILITY_MESSAGE", display);
    },
  },
  mutations: {
    SET_EMAIL(state, payload) {
      state.email = payload;
    },
    MAKE_PERMANENT_DRAWER(state) {
      state.navbar.permanent = true;
      state.navbar.clipped = false;
      state.toolbar.clippedLeft = false;
    },
    TOGGLE_MINI_DRAWER(state) {
      state.navbar.mini = !state.navbar.mini;
    },
    TOGGLE_DRAWER(state) {
      if (state.navbar.permanent) {
        state.navbar.permanent = !state.navbar.permanent;
        state.navbar.clipped = true;
        state.toolbar.clippedLeft = true;
        state.navbar.open = !state.navbar.open;
      } else {
        state.navbar.open = !state.navbar.open;
      }
    },
    SET_PART_RESULT_RETURN_PAGE(state, payload) {
      state.partsResultPage = payload;
    },
    SET_IE_VERSION(state, payload) {
      state.ieVersion = payload;
    },
    SET_DISPLAY_COMPATIBILITY_MESSAGE(state, payload) {
      state.displayCompatibilityMessage = payload;
    },
    SET_PART_ALLLINES_RESULT_RETURN_PAGE(state, payload) {
      state.partsResultsAlllines = payload;
    },
    SET_BUYER_ASSIST_RESULT_RETURN_PAGE(state, payload) {
      state.buyerAssistResults = payload;
    },
    SET_BUYER_ASSIST_INFO_RETURN_PAGE(state, payload) {
      state.buyerAssistInfo = payload;
    },
    SET_THEME(state, skin) {
      console.log("skin theme", skin)
      state.skin = skin;
    },
  }
};
